import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { setAdexMemo } from 'lib/api/adex';
import BasicModal from 'components/organisms/Modal/Basic';
import BasicModalHeader from 'components/molecules/Modal/Header';
import BasicModalSection from 'components/molecules/Modal/Section';
import BasicModalFooter from 'components/molecules/Modal/Footer';
import MbInput from 'components/atoms/MbInput';

const useStyles = makeStyles((theme) => ({
  deleteModal: {
    width: 400,
  },
  textBox: {
    backgroundColor: '#fff',
  },
}));
let modifyMemo = '';
const MemoModal = (props) => {
  const classes = useStyles();
  const { handleToggleModal, isOpen, memo, setMemos, scriptNo } = props;
  const { t } = useTranslation();

  const handleModalClose = () => {
    handleToggleModal(false);
  };

  const onKeyChange = () => (e) => {
    modifyMemo = e.target.value;
  };

  const handleModalOk = () => {
    setAdexMemo({ mediaScriptNo: scriptNo, memo: modifyMemo })
      .then((response) => {
        const data = response.data;
        alert(data.message);
        let memos = [];
        memos[scriptNo] = modifyMemo;
        setMemos(memos);
        handleModalClose();
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  return (
    <>
      <BasicModal open={isOpen}>
        <BasicModalHeader
          headerOpen={false}
          closeBtn
          closeOnClick={handleModalClose}
        ></BasicModalHeader>
        <BasicModalSection className={classes.deleteModal}>
          <MbInput
            className={classes.textBox}
            name="memo"
            defaultValue={memo}
            margin="normal"
            placeholder={t('메모')}
            onChange={onKeyChange()}
            style={{
              width: 150,
              margin: 0,
              height: 35,
            }}
          />
        </BasicModalSection>
        <BasicModalFooter
          confirmOnClick={handleModalOk}
          cancelOnClick={handleModalClose}
          confirmBtnOpen={true}
          confirmBtnTitle={t('저장')}
          cancelBtnOpen={true}
          cancelBtnTitle={t('취소')}
        />
      </BasicModal>
    </>
  );
};
export default MemoModal;
